export default __webpack_public_path__ + "2e482fbb62786502993e2b75f6209b7c.coffee";